import { createFileRoute, Outlet } from '@tanstack/react-router'
import { SettingsWrapper } from '../../../../ui'

export const Route = createFileRoute('/_auth/company/$companyId/settings')({
	component: RouteComponent,
})

function RouteComponent() {
	return (
		<SettingsWrapper>
			<Outlet />
		</SettingsWrapper>
	)
}
